import io from "socket.io-client";
import { PORT } from "./constant";

let socket = null;

export const connectSocket = (vendorId) => {
  if (!socket && vendorId) {
    socket = io(PORT, {
        autoConnect: false,
        reconnection: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        timeout: 20000,
      query: { vendorId },
    });

    socket.connect();
  }

  return socket;
};

export const getSocket = () => socket;

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};